import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// i18n must initialize before App renders (sets up language detection + RTL)
import './i18n/config';
import App from './App';
import './styles/index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
